import React from 'react';
import { Hero } from '../blocks/hero';
import SimpleBanner from '../blocks/simple_banner';
import Text from '../blocks/text';
import Articles from '../blocks/academy/articles';
import Diploma from '../fragments/diploma';
import PlatformCards from '../fragments/platform-cards';
import ImageBlock from '../blocks/image';
import Newsletter from '../blocks/newsletter';
import AcademyMenu from '../blocks/academy/academy-menu';
import Article from '../blocks/academy/article';
import Helpful from '../blocks/academy/helpful';
import Glossary from '../blocks/academy/glossary';
import RelatedArticles from '../fragments/related-articles';

const AcademyProxy = ({
  block,
  isFront,
  parentPage,
  siteVars,
  article,
  featuredCategories,
  glossaryItems,
}: AcademyProxyProps) => {
  switch (block._template) {
    case 'block__hero':
      let imagePositionClass = 'bg-right';
      if (block.image_position === 'Full width') {
        imagePositionClass = 'bg-fullwidth';
      } else if (block.image_position === 'Stick to bottom') {
        imagePositionClass = 'bg-bottom';
      } else if (block.image_position === 'Right Center') {
        imagePositionClass = 'bg-centered';
      }

      let textPositionClass = 'text-left';
      if (block.text_position === 'Center') {
        textPositionClass = 'text-center';
      }

      return (
        <Hero
          block={{
            ...block,
            image_position_class: imagePositionClass,
            text_position_class: textPositionClass,
          }}
          isFront={isFront}
          parentPage={parentPage}
          article={article}
          vars={siteVars}
        />
      );
    case 'block__simple_banner':
      return <SimpleBanner block={block} />;
    case 'block__text':
      return <Text block={block} />;
    case 'block__articles':
      return (
        <Articles
          block={block}
          data={featuredCategories}
        />
      );
    case 'block__diploma':
      return <Diploma block={block} />;
    case 'block__platform_cards':
      return <PlatformCards block={block} />;
    case 'block__image':
      return <ImageBlock block={block} />;
    case 'block__contact_form_newsletter':
      return <Newsletter block={block} />;
    case 'block__academy_menu':
      return (
        <AcademyMenu
          block={block}
          category={article.Category}
        />
      );
    case 'block__article':
      return (
        <Article
          block={block}
          data={article}
        />
      );
    case 'block__helpful':
      return (
        <Helpful
          block={block}
          data={article}
        />
      );
    case 'block__glossary':
      return (
        <Glossary
          block={block}
          glossaryEdges={glossaryItems}
        />
      );
    case 'block__related_articles':
      return (
        <RelatedArticles
          block={block}
          data={article.RelatedArticles}
        />
      );
    default:
      return <p>Missing block.</p>;
  }
};

export default AcademyProxy;
